<template>
  <div class="form__field searchableDropdown">
    <FormInput class="search-input" :label="label" v-model="form.fields.searchQuery" :name="name" required />

    <div :class="['dropdown', { 'visible': dropdownOpen }]" ref="dropdown">
      <div class="name-to-add">
        <p>{{ form.fields.searchQuery.value }}</p>
        <button class="btn --white --border" :disabled="form.fields.searchQuery.value === ''"
          @click.prevent="createEmployee">
          {{ $t('form.create.employee.button') }}
        </button>
      </div>
      <ul class="searchable-options-list">
        <li class="btn --white searchable-option" v-for="option in filteredOptions" :key="option.key"
          @click.stop="selectOption($event)" :employee_id="option.key">
          {{ option.value }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { FormInput } from '@/components/form/fields'

export default {
  name: 'FormSearchableDropdown',
  components: {
    FormInput
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dropdownOpen: false,
      form: {
        fields: {
          searchQuery: {
            value: '',
            valid: false
          },
        },
        valid: false
      },
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(option =>
        option.value
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            this.form.fields.searchQuery.value
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
          )
      )
    }
  },
  methods: {
    handleClickOutside(event) {
      const inputElement = this.$el.querySelector('.search-input input')

      if (inputElement && inputElement.contains(event.target)) {
        this.dropdownOpen = true
      } else if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.dropdownOpen = false
      }
    },
    selectOption(event) {
      const selectedOptions = document.querySelectorAll('.searchable-option.selected')

      selectedOptions.forEach(option => {
        option.classList.remove('selected')
      })

      if (event.target.getAttribute('employee_id') === this.modelValue.value) {
        this.form.fields.searchQuery.value = ''
        this.form.fields.searchQuery.valid = false
        this.$emit('update:modelValue', {
          value: '',
          valid: this.form.fields.searchQuery.valid
        })
      } else {
        const value = event.target.innerText

        event.target.classList.add('selected')
        this.form.fields.searchQuery.value = value
        this.form.fields.searchQuery.valid = true

        this.$emit('update:modelValue', {
          value: event.target.getAttribute('employee_id'),
          valid: true
        })
      }
    },
    async createEmployee() {
      const now = new Date

      const currentId = await this.$employee.store({
        birthday_day: null,
        birthday_month: null,
        employment_start_date: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, 0)}-${String(now.getDate()).padStart(2, 0)}`,
        full_name: this.form.fields.searchQuery.value
      })

      this.$emit('update:modelValue', {
        value: currentId,
        valid: true
      })

      document.querySelectorAll('.searchable-option.selected').forEach(element => element.classList.remove('selected'))
      document.querySelector(`.searchable-option[employee_id="${currentId}"]`).classList.add('selected')

      this.$popup.report(`${this.$t('popup.theEmployee')} ${this.$t('popup.createdElement')}`, false)
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },
}
</script>